<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7Cekxl/Images/9780316258883_cover_epub.jpg?1733085643011" alt="This image is the cover for the book All the Pretty Little Horses, Newsflesh"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All the Pretty Little Horses, Newsflesh
      </h1>
      <p class="bookDescription body article font2">
        <b>A Newsflesh novella from the <i>New York Times</i> bestselling author that brought you <i>Feed</i>, Mira Grant.</b><br/><br/>Stacy and Michael Mason are among the most famous heroes of the zombie apocalypse. Stacy, however, has fallen into a deep depression after having to shoot their infected son. In the aftermath of the pandemic, they start publicly documenting the recovery effort, which Michael hopes will take Stacy's mind off of her trauma and help her recover.<br/><br/>As they film the rescue of an enclave of orphans and report on the orphanages that have sprung up to care for traumatized, parent-less children, they begin to consider the last, greatest step of recovery: adoption.<br/><br/>More from Mira Grant:<br/> <br/><b>Newsflesh</b><br/><i>Feed</i><br/><i>Deadline</i><br/><i>Blackout</i><br/><i>Feedback</i><br/> <br/><i>Rise</i><br/> <br/><b>Newsflesh Short Fiction</b><br/><i>Countdown</i><br/><i>Everglades</i><br/><i>Sand Diego 2014</i><br/><i>How Green This Land, How Blue This Sea</i><br/><i>The Day the Dead Came to Show and Tell</i><br/><i>Please Do Not Taunt the Octopus</i><br/><i>All the Pretty Little Horses</i><br/><i>Coming to You Live</i><br/><br/> 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mira Grant
      </h2>
      
      <p class="authorDescription body article"><B>Mira Grant</B> lives in California, sleeps with a machete under her bed, and highly suggests you do the same.  Mira Grant is the pseudonym of Seanan McGuire -- winner of the 2010 John W. Campbell Award for best new writer.  Find out more about the author at www.miragrant.com or follow her on twitter @seananmcguire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef975dba